import selectInput from './selectInput.directive.js';
export default angular.module('app.selectInput', [])
	.directive('ertSelectInput', selectInput).name;
